// src/components/store/sections/deal/useProductTimer.ts
"use client";

import { useState, useEffect } from "react";

export function useProductTimer(product: any) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 12,
    minutes: 45,
    seconds: 23,
  });

  useEffect(() => {
    const customEnd =
      product?.deal_end_date ||
      product?.deal_ends_at ||
      product?.countdown_end ||
      product?.discount_until;

    if (customEnd) {
      const updateCustom = () => {
        const diff = new Date(customEnd).getTime() - new Date().getTime();
        if (diff <= 0) {
          setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
          return;
        }
        setTimeLeft({
          days: Math.floor(diff / (1000 * 60 * 60 * 24)),
          hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((diff / (1000 * 60)) % 60),
          seconds: Math.floor((diff / 1000) % 60),
        });
      };
      updateCustom();
      const timer = setInterval(updateCustom, 1000);
      return () => clearInterval(timer);
    } else {
      // Default Midnight Rolling Countdown
      const updateDefault = () => {
        const now = new Date();
        const endOfDay = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          23,
          59,
          59
        );
        const diff = endOfDay.getTime() - now.getTime();
        setTimeLeft({
          days: 0,
          hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((diff / (1000 * 60)) % 60),
          seconds: Math.floor((diff / 1000) % 60),
        });
      };
      updateDefault();
      const timer = setInterval(updateDefault, 1000);
      return () => clearInterval(timer);
    }
  }, [
    product?.deal_end_date,
    product?.deal_ends_at,
    product?.countdown_end,
    product?.discount_until,
  ]);

  return timeLeft;
}